import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import truncate from "truncate-html";
import CircularProgress from "@mui/material/CircularProgress";

const EventList = ({ events, selectedLocation = { title: "East Africa" }, loading = false }) => {
  const navigate = useNavigate();
  const truncateHtml = (htmlContent, length = 100) => {
    return truncate(htmlContent, {
      length: length,
      ellipsis: "...",
      keepImageTag: true,
    });
  };
  const galleryImageUrl = (image) => {
    const parts = image.split('_');
    if (parts.length >= 3) {
      parts.splice(3, 0, 'img_250');
      image = parts.join('_');
    }
    return `${process.env.REACT_APP_BASE_IMAGE_URL}gallery/${image}`;
  };
  const imageUrl = (url) => {
    return process.env.REACT_APP_BASE_IMAGE_URL + url;
  };

  const handleClickOpen = (eventId) => {
    navigate(`/event/${eventId}`);
  };
  return (
    <Container sx={{ mt: 5, mb: 5 }}>
      {loading ? (
        <div className="flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        events?.map((day, index) => (
          <MKBox key={index} mb={4}>
            <Grid container spacing={2} className="pl-5">
              <Grid item xs={12} md={3} container spacing={2} mt={2}>
                {/* <MKTypography variant="h5" className="text-purple-800" gutterBottom>
                {day.date}
              </MKTypography> */}
              <div className="text-xl font-bold text-purple-800">
                  {day.date}
              </div>
            </Grid>
            <Grid item xs={12} md={9} container spacing={2} className="">
              {day.events?.map((event, idx) => (
                <Grid container spacing={2} mt={2} key={idx}>
                  {event.images.length == 0 ? (
                  <Grid item xs={12} md={1} style={{ textAlign: "right" }}>
                    <img
                      src={imageUrl(event.image)}
                      alt={event.title}
                      className="mt-4 w-fit sm:block hidden"
                      onClick={() => handleClickOpen(event.id)}
                      style={{ cursor: "pointer" }}
                    />
                  </Grid>
                  ) : ""}
                  <Grid
                    item
                    xs={12}
                    md={event.images.length !== 0 ? 10 : 9}
                    onClick={() => handleClickOpen(event.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <MKTypography variant="h5">{event.title} {(selectedLocation.title !== "East Africa" ? "" : " - " + event.city )}</MKTypography>
                    <MKTypography variant="h6">{(event.venue_name? event.venue_name + ' / ' : '') + event.location} </MKTypography>
                    <MKTypography
                      variant="body2"
                      dangerouslySetInnerHTML={{
                        __html: truncateHtml(event.description, 200),
                      }}
                    ></MKTypography>
                    {event.images.length !== 0 ? (
                      <div className="flex gap-3">
                        {event.images.map((image, index) => (
                          <img
                            key={index}
                            src={galleryImageUrl(image)}
                            alt={"Image" + index}
                            className="w-16 rounded-lg"
                          />
                        ))}
                      </div>
                    ) : ''}
                  </Grid>
                  <Grid item xs={12} md={2} style={{ textAlign: "right" }}>
                    <MKTypography variant="body2">{event.time}</MKTypography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <hr style={{ marginTop: "25px", fontSize: "1px", color: "rgba(200, 200, 200, 0.18)" }} />
        </MKBox>
      )))}
    </Container>
  );
};

EventList.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      events: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          time: PropTypes.string.isRequired,
          image: PropTypes.string,
          location: PropTypes.string,
          ticketPrice: PropTypes.string,
          city: PropTypes.string,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default EventList;
